<div class="td-wb-consolidated-agreements-list__container">
  @if (getTermsConditions()) {
    @if (!hideHeaders()) {
      <h1 class="td-wb-consolidated-agreements-list__title"
          translate="tdWb.platform.agreements.TERMS_CONDITIONS_TITLE"></h1>
    }
    <div class="td-wb-consolidated-agreements-list__section">
      <a class="td-wb-consolidated-agreements-list__link"
         tabindex="0"
         [attr.id]="'td-wb-agreement-link-' + getTermsConditions()"
         (click)="onAgreementSelected(getTermsConditions())"
         (keydown.enter)="onAgreementSelected(getTermsConditions())">
        <td-wb-icon iconId="documents"
                    size="16"
                    [inline]="true"
                    iconType="primary" />
        <span translate="tdWb.platform.agreements.TERMS_CONDITIONS"></span>
      </a>
      @if (alreadySigned() && fplPermisson) {
        <div class="td-wb-consolidated-agreements-list__fpl-agreement">
          <a class="td-wb-consolidated-agreements-list__link"
             tdWbHref="modal.preferences-exchange-agreements"
             [tdWbHrefParams]="{ agreement: getStockLendingAgreement() }"
             tdWbHrefTaggingEvent="agreements:stocklending:t&c"
             id="td-wb-agreement-link-stock-lending">
            <td-wb-icon iconId="documents"
                        size="16"
                        [inline]="true"
                        iconType="primary"/>
            <span translate="tdWb.platform.agreements.STOCK_LENDING_TERMS_AND_CONDITIONS"></span>
          </a>
        </div>
      }
    </div>
  }
  <div class="td-wb-consolidated-agreements-list__section">
    @if (!hideHeaders()) {
      <h1 class="td-wb-consolidated-agreements-list__title"
          translate="tdWb.platform.agreements.EXCHANGE_AGREEMENTS"></h1>
    }
    @if (newUser()) {
      <p class="td-wb-consolidated-agreements-list__description"
         translate="tdWb.platform.agreements.NEW_USER_EXCHANGE_AGREEMENTS"></p>
    }
    @if (alreadySigned()) {
      <p class="td-wb-consolidated-agreements-list__description"
         translate="tdWb.platform.agreements.ALREADY_SIGNED_EXCHANGE_AGREEMENTS"></p>
    }
    @if (activeTrader()) {
      <p class="td-wb-consolidated-agreements-list__description"
         translate="tdWb.platform.agreements.ACTIVE_TRADER_EXCHANGE_AGREEMENTS"></p>
    }
    @for (exchangeAgreement of getExchangeAgreements(); track exchangeAgreement) {
      <div class="td-wb-consolidated-agreements-list__exchange-agreement">
        <a class="td-wb-consolidated-agreements-list__link"
           tabindex="0"
           [attr.id]="'td-wb-agreement-link-' + exchangeAgreement?.agreementType"
           (click)="onAgreementSelected(exchangeAgreement)"
           (keydown.enter)="onAgreementSelected(exchangeAgreement)">
          <td-wb-icon iconId="documents"
                      size="16"
                      [inline]="true"
                      iconType="primary"/>
          @if (superscriptRequired()) {
            <span
              [innerHTML]="'tdWb.platform.agreements.agreementNamesWithSup.' + exchangeAgreement?.agreementType | tdWbTranslate"></span>
          } @else {
            <span
              [translate]="'tdWb.platform.agreements.agreementNamesNoSup.' + exchangeAgreement?.agreementType"></span>
          }
          <span class="td-wb-vh">- <span translate="tdWb.platform.agreements.OPEN_AGREEMENT"></span></span>
        </a>
      </div>
    }
  </div>
</div>
